import React, { useState, useEffect } from 'react';
import CommonMessage from "../components/CommonMessage";
import { contractCall, web3AccountCheck } from '../helper/web3helper';
import hostContract from '../web3/hostContract.json';
import web3Config from '../web3/web3Config.json';
import { formatMessageList, getWeb2emails, formatEmailDetails } from '../helper/dataFormatHelper';
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useWalletReconnectionWithLoader } from '../helper/useWalletReconnection';
import { getEmails, getSentEmails } from '../helper/emailHelper';
import { reportError, toErrorString } from '../utils/errorLogger';
const cookies = new Cookies();

function Favourite() {
  const dispatch = useDispatch();
  const [user] = useState(cookies.get("userObject"));
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [web3Contract, setWeb3Contract] = useState('');
  const [allBoxList, setAllBoxList] = useState([]);
  const [readList, setReadList] = useState([]);
  const [unreadList, setUnreadList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rendered, setRendered] = useState(false);
  const [renderTime, setRenderTime] = useState(new Date());
  const userName = user.name;
  const [text, setText] = useState("")

  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
  }, []);

  useWalletReconnectionWithLoader(
    setLoader,
    setText,
    web3AccountCheck,
    setWeb3,
    setAccount,
    () => setEmail(),
    web3Contract
  );

  useEffect(() => {
    if (account && web3Value) {
      // const contractInstance = new web3Value.eth.Contract(hostContract.contract, web3Config.CONTRACT);
      const contractInstance = contractCall(hostContract.contract, web3Config.CONTRACT);
      setWeb3Contract(contractInstance);
    }
  }, [web3Value, account]);

  const getRefreshMessage = useSelector((state) => state.refreshMessage);
  useEffect(() => {
    if (web3Contract || getRefreshMessage) {
      setEmail();
    }
  }, [web3Contract, getRefreshMessage]);


  useEffect(() => {
    if (web3Contract) {
      setEmail();
    }
  }, []);


  async function setEmail(loaderRequired = true) {
    // Tracks whether WE turned the loader on, so the finally below only ever clears a loader this call
    // raised — when web3Contract isn't ready yet the initial loader must stay up.
    let loaderShown = false;
    try {
      if (web3Contract) {
        if (loaderRequired) {
          setLoader(true);
          setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
          setRendered(false);
          loaderShown = true;
        }
        const sentEmailList = await getSentEmails(userName);
        const emailList = await getEmails(userName);
        const updatedEmailList = await formatEmailDetails(emailList);
        const sentUpdatedEmailList = await formatEmailDetails(sentEmailList);
        const formattedResult = updatedEmailList
          .filter(email => email.senderName)
          .map(email => ({
            mailtype: "web3emails",
            id: parseInt(email.id),
            subject: email.subject,
            encryptedData: email.encryptedData,
            created_at: email.receivedDate,
            isStarred: email.isStarred,
            sender: email.senderName,
            isRead: email.isRead,
            header: email.emailDetails,
            isCC: email.isCC,
            isBCC: email.isBCC,
            ...email
          })).filter(email => email.isStarred && !email.isDelete && !email.isSaved);
        const sentFormattedResult = sentUpdatedEmailList
          .filter(email => email.senderName)
          .map(email => ({
            mailtype: "Senttrash",
            id: parseInt(email.id),
            subject: email.subject,
            encryptedData: email.encryptedData,
            created_at: email.receivedDate,
            isStarred: email.isStarred,
            sender: email.senderName,
            isRead: true,
            header: email.emailDetails,
            receiver: email.emailDetails,
            ...email
          })).filter(email => email.isStarred && !email.isArchive && email.isfolder !== 'true' && email.isfolder !== true)
        const { allList } = await formatMessageList(formattedResult.reverse(), "Important");
        const sentEmail = await formatMessageList(sentFormattedResult.reverse(), "Sent");
        const formattedresponse = await getWeb2emails(userName);
        const web2deletedemails = formattedresponse.filter((data) => {
          if (data.delete !== 1 && data.delete !== 3 && data.isStarred === true) {
            return data
          }
          return null;
        })
        const sortEmails = (allList, web2deletedemails) => {
          const combined = [...allList, ...web2deletedemails, ...sentEmail.allList];
          const sortedCombined = combined.sort((a, b) => {
            const dateA = new Date(a.date || a.receivedDate);
            const dateB = new Date(b.date || b.receivedDate);
            return dateB - dateA;
          });
          return sortedCombined;
        };
        const sortedresponse = sortEmails(allList, web2deletedemails);
        setAllBoxList(sortedresponse);
        const readMessage = sortedresponse.filter(message => message.isRead);
        const unReadMessage = sortedresponse.filter(message => !message.isRead);
        setReadList(readMessage);
        setUnreadList(unReadMessage);
        if (loaderRequired) {
          setRendered(true);
        }
      }

    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      const userName = localStorage.getItem('UserName');
      reportError({
        endpoint: '-',
        message: `FileName: Favourite.js, Fun: setEmail, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.log("error", error);
    } finally {
      // The catch above only logged: any throw left the spinner up for good. Clearing here covers both the
      // success and the failure path (setRendered is idempotent).
      if (loaderShown) {
        setRendered(true);
        setLoader(false);
        setText("");
      }
    }
  }
  const refreshCount = useSelector((state) => state.refreshCount);
  const reRender = () => {
    dispatch({ type: "REFRESH_COUNT", payload: !refreshCount });
    setEmail();
  }

  useEffect(() => {
    if (rendered) {
      setLoader(false)
      setText("")
    }
  }, [rendered]);


  return (
    <div className="inbox-container">
      <CommonMessage messageList={allBoxList} unreadList={unreadList} readList={readList} pageType={"Important"} loader={loader} reRender={reRender} text={text} />
    </div>
  );
}

export default Favourite;
